/**
 * Created by MinhQuan on 4/25/2016.
 */

angular.module('common.directive.country', ['common.helper', 'common.model.geoarea']).component('agCountry',{
    bindings: {
        countryId: '@',
        countryCodeId: '@',
        countryDescription: '@',
        countryCodeDescription: '@',
        hasCountryGroup: '@',
        country: '<',
        control: '=',
        simulationDate: '<',       
        onCountryChange: '&',
        onHandleError: '&'
    },
    controller: function (GeographicalAreaModel, CommonHelper, $filter, $translate, $rootScope, $q) {
        var ctrl = this;

        ctrl.handleError = function (errorCode, errorParams) {
            ctrl.onHandleError({
                error: {
                    errorCode: errorCode, errorParams: errorParams
                }
            });
        };

        ctrl.getCountries = function(){
            if (!ctrl.countriesAndRegions){
                return [];
            }
            var countries = ctrl.countriesAndRegions.items.filter(function(geoArea){
                return geoArea.type === 'C';
            });
            return countries.sort(function (country1, country2) {
                return $filter('description')(country1.descriptions).localeCompare($filter('description')(country2.descriptions), CommonHelper.getLanguageCode($translate.use()));
            });
        };

        ctrl.getRegions = function(){
            if (!ctrl.countriesAndRegions){
                return [];
            }
            var regions = ctrl.countriesAndRegions.items.filter(function(geoArea){
                return geoArea.type === 'R';
            });
            return regions.sort(function (region1, region2) {
                return $filter('description')(region1.descriptions).localeCompare($filter('description')(region2.descriptions),  CommonHelper.getLanguageCode($translate.use()));
            });
        };

        ctrl.getGroups = function(){
            if (!ctrl.countriesAndRegions){
                return [];
            }
            var groups = ctrl.countriesAndRegions.items.filter(function(geoArea){
                return geoArea.type === 'G';
            });
            return groups.sort(function (group1, group2) {
                return $filter('description')(group1.descriptions).localeCompare($filter('description')(group2.descriptions),  CommonHelper.getLanguageCode($translate.use()));
            });
        };

        ctrl.loadCountriesAndRegions = function(){
            ctrl.countries = ctrl.getCountries();
            ctrl.regions = ctrl.getRegions();
            ctrl.groups = ctrl.getGroups();
        };

        $rootScope.$on('$translateChangeSuccess', function () {
            ctrl.loadCountriesAndRegions();
        });

        ctrl.reload = function(reloadDate){
            var deferred = $q.defer();
            if (reloadDate){
                GeographicalAreaModel.getCountriesOfOrigin(reloadDate).then(function (countries) {
                    ctrl.countriesAndRegions = countries;
                    // If there is selected country, only display it when it exists at reloadDate
                    let found = false;
                    if (ctrl.country) {
                        //Find the country from the list
                        for (let i = 0; i < ctrl.countriesAndRegions.items.length; i++) {
                            let geoAreaId = ctrl.countriesAndRegions.items[i].id;
                            if (ctrl.country === geoAreaId) {
                                ctrl.countryCode = geoAreaId;
                                found = true;
                                break;
                            }
                        }
                    }
                    if (!found){
                        ctrl.countryCode = null;
                        ctrl.country = null;
                    }
                    ctrl.loadCountriesAndRegions();
                    deferred.resolve();
                }, function (error) {
                    ctrl.handleError(error.data.code, error.data.params);
                    deferred.reject(error);
                });
            } else {
                deferred.resolve();
            }

            return deferred.promise;
        };

        //Update the country select box when user enters the country code in the input text
        ctrl.countryCodeChange = function () {
            var countryCode = CommonHelper.removeSpaceCharacters(ctrl.countryCode);

            //Wait until user enters 2 characters
            if(countryCode.length === 1 || countryCode.length === 3){
                return;
            } else {

                //Find the country from the list
                let found = false;
                for (let i = 0; i < ctrl.countriesAndRegions.items.length; i++) {
                    let geoAreaId = ctrl.countriesAndRegions.items[i].id;
                    if (ctrl.countryCode.toUpperCase() === geoAreaId) {
                        ctrl.country = geoAreaId;
                        found = true;
                        break;
                    }
                }
                if (!found){
                    ctrl.country = null;
                }

                ctrl.onCountryChange({country: ctrl.country});
            }

        };

        //Update the country code when the country of origin select box is changed
        ctrl.countryChange = function () {
            ctrl.countryCode = ctrl.country;
            ctrl.onCountryChange({country: ctrl.country});
        };

        ctrl.validate = function(){
            var countryCode = CommonHelper.removeSpaceCharacters(ctrl.countryCode);
            var country = CommonHelper.removeSpaceCharacters(ctrl.country);
            if (countryCode.toUpperCase() !== country.toUpperCase()){
                return "i18n.common.validation.country.code.invalid";
            }

            return null;
        };

        ctrl.updateCountryCode = function(countryCode){
            ctrl.countryCode = countryCode;
        };

        ctrl.init = function () {
            if (ctrl.control){
                ctrl.control.reload = ctrl.reload;
                ctrl.control.validate = ctrl.validate;
                ctrl.control.updateCountryCode = ctrl.updateCountryCode;
            }
            if(!ctrl.countryId){
                ctrl.countryId = "country";
            }
            if(!ctrl.countryCodeId){
                ctrl.countryCodeId = "countryCode";
            }
            
            // The country list must always be loaded when initializing country drop-box component.
            if (ctrl.simulationDate) {
                ctrl.reload(ctrl.simulationDate);
            } else {
                ctrl.reload(new Date());
            }
        };

        ctrl.init();
    },
    templateUrl: 'common/directive/country.tmpl.html'
});




// WEBPACK FOOTER //
// ./app/common/directive/country.directive.js